import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  INFLUENCERS_CAMPAIGN_PATH,
  INFLUENCERS_CAMPAIGN_ADD_PATH,
  INFLUENCERS_CAMPAIGN_UPDATE_PATH,
} from "utils/constants/paths";

const InfluencersCampaign = Loadable(React.lazy(() => import("./View")));
const InfluencersCampaignAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const InfluencersCampaignRoute: IRouteItem = {
  path: INFLUENCERS_CAMPAIGN_PATH,
  iconName: "Profile2User",
  element: React.createElement(InfluencersCampaign),
  name: "Influencers Campaign",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: INFLUENCERS_CAMPAIGN_ADD_PATH,
      element: React.createElement(InfluencersCampaignAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: INFLUENCERS_CAMPAIGN_UPDATE_PATH,
      element: React.createElement(InfluencersCampaignAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
